<template>
  <MglMarker :coordinates="coordinates" @click="$emit('click', id)">
    <template slot="marker">
      <div class="marker" :class="{active}">{{ name }}</div>
    </template>
  </MglMarker>
</template>

<script>
import {MglMarker} from 'vue-mapbox';

export default {
  components: {MglMarker},
  props: {
    coordinates: {
      type: Array,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    active: Boolean,
  },
};
</script>
<style scoped>
.marker {
  background: rgba(255, 255, 255, 0.5);
  border-radius: 6.50174px;
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
  text-align: center;
  color: var(--primary-color, hsl(208, 100%, 41%));
  transition: all 0.3s ease;
  display: inline-block;
  position: absolute;
  left: 0;
  padding: 3px 5px;
  cursor: pointer;
  opacity: 0;
}

.marker.active {
  background: #f5f5f5;
  box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.25);
  border-radius: 12px;
  padding: 7px 10px;
  opacity: 1;
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-transform: capitalize;
  padding: 12px 16px;
}
</style>
